import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  FormControl,
  Select,
  Typography,
  MenuItem,
  Tooltip,
  TableRow,
  TableCell,
  IconButton,
  TableHead,
  TableBody,
  TableContainer,
  Paper,
  Table,
} from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import { CustomNoRowsOverlay } from "../../components/common/OverlayGrid";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Offcanvas, OffcanvasBody } from "react-bootstrap";
// import { usePersistentFilter } from "../../assets/hooks/usePersistentFilter";
import { useSelector } from "react-redux";
import { CustomTasksCalender } from "./CustomTasksCalender";
import SearchBar from "../../components/SearchBar";
import { CiExport } from "react-icons/ci";
import { FiLayers } from "react-icons/fi";
import { useTheme } from "../../ThemeContext";
// import BenchImage from "../../assets/images/tasks/BenchImage.png";
import WorkStatusTable from "./WorkStatusTable";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { createEntity, filterEntities } from "../../apis/apiService";
import { toast } from "react-toastify";
import { format } from "date-fns";
import { useFetchAllDepartmentsQuery, useFetchWorkStatusQuery } from "../../slice/logdetailSlice";
import Loader from "../../components/common/Loader";
import BenchSummary from "./BenchSummary";
import dayjs from "dayjs";
import Swal from "sweetalert2";

const filterOptions = {
  status: [
    { value: "0", label: "All Status"},
    { value: "1", label: "In Bench"},
    { value: "2", label: "Shortly Available"},
    { value: "3", label: "Engaged"},
    { value: "4", label: "Long-term"},
  ],
  department: [
    { label: "All", value: 1 },
    { label: "Backend", value: 2 },
    { label: "Frontend", value: 3 },
    { label: "Mobile Application", value: 4 },
    { label: "Tester", value: 5 },
  ],
};

function WorkStatus() {
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  // const [rows, setRows] = useState([]);
  //console.log("login_user in pproject:", login_user);
  const { role: login_user_role } = login_user;
  const [searchTerm, setSearchTerm] = useState("");
  const [clearFilter, setClearFilter] = useState(false);
  const [showSummary, setShowSummary] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [checkedRows, setCheckedRows] = useState({});
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [departmentFilter, setDepartmentFilter] = useState("");
  const [workStatusData, setWorkStatusData] = useState([]);
  const intervalRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const hasDownloaded = useRef(false);
  // const [filter, setFilter] = usePersistentFilter(
  //   "timesheetModuleFilter",
  //   login_user_role === "CLIENT" || login_user_role === "ADMIN" ? 1 : 6
  // );
  // const [benchFilter, setBenchFilter] = useState("0");
  const [benchFilter, setBenchFilter] = useState("0");

  const [isExport, setIsExport] = useState(false);
  // const [selectionRange, setSelectionRange] = useState(() => {
  //   const saved = localStorage.getItem("workStatus_date_range");

  //   if (saved) {
  //     try {
  //       const parsed = JSON.parse(saved);
  //       return {
  //         ...parsed,
  //         startDate: new Date(parsed.startDate),
  //         endDate: new Date(parsed.endDate),
  //       };
  //     } catch (error) {
  //       console.error("Invalid stored date range:", error);
  //     }
  //   }

  //   // default value if nothing in localStorage
  //   return {
  //     startDate: new Date(),
  //     endDate: new Date(),
  //     key: "selection",
  //   };
  // });

  const [selectionRange, setSelectionRange] = useState(() => {
    // const saved = localStorage.getItem("workStatus_date_range");

    // if (saved) {
    //   try {
    //     const parsed = JSON.parse(saved);

    //     return {
    //       ...parsed,
    //       startDate: new Date(parsed.startDate),
    //       endDate: new Date(parsed.endDate),
    //     };
    //   } catch (error) {
    //     console.error("Invalid stored date range:", error);
    //   }
    // }

    // ❌ No saving to localStorage here
    // ✅ Just return today as the default date
    return {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    };
  });

  useEffect(() => {
    // save to localStorage whenever selectionRange changes
    localStorage.setItem(
      "workStatus_date_range",
      JSON.stringify(selectionRange),
    );
  }, [selectionRange]);

  const [expandedRows, setExpandedRows] = useState({});
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [expandedGroups, setExpandedGroups] = useState({});
  const {
    data: workStatusResult,
    isLoading,
    refetch: fetch_work_status,
  } = useFetchWorkStatusQuery({
    date: format(selectionRange.startDate, "yyyy-MM-dd"),
    department_id: departmentFilter || "",
    search: searchTerm,
    work_status: benchFilter,
    export: false,
  });

  const fetch_work_status_data = Array.isArray(workStatusResult)
    ? workStatusResult
    : workStatusResult?.data || [];

  const benchDetails = workStatusResult?.meta || {};

  const {
    data: allDepartments = [],
    refetch: fetch_all_departments,
    isError: fetchdepError,
  } = useFetchAllDepartmentsQuery();

  const selectedDepartmentName = React.useMemo(() => {
    if (!departmentFilter) return "All Departments";
    const found = allDepartments.find(
      (dept) => String(dept.department_id) === String(departmentFilter)
    );
    return found ? found.department_name : "All Departments";
  }, [departmentFilter, allDepartments]);

  const [expandedDepts, setExpandedDepts] = useState({});

  const toggleDept = (deptId) => {
    setExpandedDepts((prev) => ({
      ...prev,
      [deptId]: !prev[deptId],
    }));
  };

  // console.log("fetched data", fetch_work_status_data);

  const toggleExpandRow = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId], // Toggle expansion for the clicked row
    }));
  };

  const handleCheckboxChange = (taskId) => {
    setCheckedRows((prev) => ({
      ...prev,
      [taskId]: !prev[taskId],
    }));
  };

  useEffect(() => {
    if (fetch_work_status_data && fetch_work_status_data.length > 0) {
      const initiallyExpanded = {};
      fetch_work_status_data.forEach((dept) => {
        initiallyExpanded[dept.department_id] = true;
      });
      setExpandedDepts(initiallyExpanded);
    }
  }, [fetch_work_status_data]);

  useEffect(() => {
    fetch_work_status();
    return () => clearInterval(intervalRef.current);
  }, [selectionRange.startDate, departmentFilter, benchFilter, searchTerm]);
  useEffect(() => {
    fetch_all_departments();
    return () => clearInterval(intervalRef.current); // Cleanup on unmount
  }, []);
  // const getWorkStaus = async (date) => {
  //   try {
  //     const requestedData = {
  //       date: format(date, "yyyy-MM-dd"),
  //       // date: "2025-06-30",
  //       department_id: "",
  //       search: "",
  //     };

  //     const taskResponse = await filterEntities(
  //       "task-allocation/work-status",
  //       requestedData
  //     );
  //     if (taskResponse.status) {
  //       console.log("Work_Status_is??>??", taskResponse.data);
  //       setWorkStatusData(taskResponse.data);
  //     }
  //   } catch (err) {
  //     toast.error(err.message);
  //     console.log("Work_Status_is Error ???", err.message);
  //   }
  // };
  const handleMenuOpen = (event, task) => {
    // console.log("params_value_for_all :", task);

    setMenuAnchor(event.currentTarget);
    setSelectedTask(task);
  };
  const handleToggle = (groupId) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [groupId]: !prev[groupId],
    }));
  };

  const handleSearchChange = async (event) => {
    const value = event.target.value;
    const trimmedValue = value.trim();
    setSearchTerm(value);

    if (trimmedValue || departmentFilter !== "" || benchFilter !== "0") {
      setClearFilter(true);
      setIsSearching(true);
    } else {
      setClearFilter(false);
      setIsSearching(false);
    }
  };

  const handleClearFilter = () => {
    setSearchTerm("");
    setDepartmentFilter("");
    setBenchFilter("0");
    setClearFilter(false);
  };

  const handleArrowClick = (direction) => {
    const currentDate = selectionRange.startDate;

    const newDate =
      direction === "prev"
        ? new Date(currentDate.setDate(currentDate.getDate() - 1))
        : new Date(currentDate.setDate(currentDate.getDate() + 1));

    setSelectionRange({
      startDate: newDate,
      endDate: newDate,
      key: "selection",
    });
  };

  // const getVisibleRows = () => {
  //   const visibleRows = [];

  //   if(workStatusData){rows.forEach((row) => {
  //     row.departments.forEach((department) => {
  //       visibleRows.push({
  //         id: department.department_name,
  //         name: department.department_name,
  //         count: department.count,
  //         isGroup: true,
  //       });

  //       if (expandedGroups[department.department_name]) {
  //         department.data.forEach((child, index) => {
  //           visibleRows.push({
  //             ...child,
  //             id: `child-${department.department_name}-${index}`,
  //             isGroup: false,
  //             project_manager_name: child.project_manager?.name || "",
  //             project_manager_id: child.project_manager?.id,
  //             skills: child.area_of_expertise
  //               .map((s) => s.skill_name)
  //               .join(", "),
  //           });
  //           console.log("Visible____Rowa", child);
  //         });
  //       }
  //     });
  //   });}

  //   return visibleRows;
  // };

  // const getVisibleRows = () => {
  //   const visibleRows = [];

  //   if (Array.isArray(workStatusData)) {
  //     workStatusData.forEach((department) => {
  //       visibleRows.push({
  //         id: department.department_name || "unnamed-dept",
  //         name: department.department_name || "No Department",
  //         count: department.count,
  //         isGroup: true,
  //       });

  //       if (expandedGroups[department.department_name]) {
  //         department.data.forEach((child, index) => {
  //           visibleRows.push({
  //             ...child,
  //             id: `child-${department.department_name}-${index}`,
  //             isGroup: false,
  //             project_manager_name: child.project_manager?.name || "",
  //             project_manager_id: child.project_manager?.user_id ?? null,
  //             skills:
  //               child.area_of_expertise?.map((s) => s.skill_name).join(", ") ||
  //               "",
  //           });
  //         });
  //       }
  //     });
  //   }

  //   return visibleRows;
  // };

  // useEffect(() => {
  //   if (
  //     isExport &&
  //     fetch_work_status_data &&
  //     typeof fetch_work_status_data === "object" &&
  //     !Array.isArray(fetch_work_status_data) &&
  //     fetch_work_status_data.file_url &&
  //     !hasDownloaded.current
  //   ) {
  //     const doc_url = fetch_work_status_data.file_url;
  //     const formattedDocUrl = doc_url.replace(/\\/g, "/");

  //     window.open(formattedDocUrl, "_blank");
  //     toast.success("Document downloaded successfully");

  //     hasDownloaded.current = true;
  //     setBenchFilter("0");
  //     setIsExport(false); // ✅ Reset here
  //   }
  // }, [fetch_work_status_data, isExport]);

  const handleTableExport = async () => {
    // Close any existing popup first
    Swal.close();

    const result = await Swal.fire({
      title: "Export Confirmation",
      text: "Are you sure you want to export the Work Status report?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Export",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#04a189",
      cancelButtonColor: "#d33",
      allowOutsideClick: true,
      allowEscapeKey: true,
      backdrop: true,
      customClass: {
        popup: "custom-swal-popup",
        title: "custom-swal-title",
        htmlContainer: "custom-swal-html",
        icon: "custom-swal-icon",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });

    if (result.isConfirmed) {
      await executeTableExport();
    }
  };

  const executeTableExport = async () => {
    const requestedData = {
      date: format(selectionRange.startDate, "yyyy-MM-dd"),
      department_id: departmentFilter || "",
      search: searchTerm,
      work_status: benchFilter,
      export: true,
    };
    try {
      const response = await filterEntities(
        "task-allocation/work-status",
        requestedData,
      );

      if (response) {
        const { file_url } = response.data;
        console.log("doc_urls2 : ", response);
        const link = document.createElement("a");
        link.href = file_url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        link.remove();
        // const formattedDocUrl = doc_url.replace(/\\/g, "/"); // Replace backslashes
        // window.open(formattedDocUrl, "_blank");
        toast.success("Work Status report has been exported successfully");
      }
    } catch (error) {
      toast.error(error.message || "Export failed");
    }

    // handleOptionsClose();
  };

  const getVisibleRows = () => {
    const visibleRows = [];

    if (Array.isArray(fetch_work_status_data)) {
      fetch_work_status_data.forEach((department) => {
        const deptName = department.department_name || "No Department";

        // Push department row
        visibleRows.push({
          id: `group-${deptName}`,
          name: deptName,
          isGroup: true,
          count: department.count,
        });

        // If group is expanded
        if (expandedGroups[deptName]) {
          department.data.forEach((user, userIndex) => {
            user.tasks.forEach((task, taskIndex) => {
              const isFirstTask = taskIndex === 0;

              visibleRows.push({
                id: `task-${user.user_id}-${task.task_allocation_id}`,
                isGroup: false,
                user_id: user.user_id,
                showUser: isFirstTask,
                user_name: user.user_name,
                designation: user.designation,
                relevant_experience: user.relevant_experience,
                skills:
                  user.area_of_expertise?.map((s) => s.skill_name).join(", ") ||
                  "",
                work_hours: task.work_hours,
                work_status: task.work_status,
                date: task.work_till,
                project_manager_name: task.project_manager?.name || "",
                project_name: task.project?.title || "",
                task_list: task.task_list,
              });
            });
          });
        }
      });
    }

    return visibleRows;
  };

  // const getVisibleRows = () => {
  //   const visibleRows = [];
  //   console.log("visble_rows", fetch_work_status_data);

  //   if (Array.isArray(fetch_work_status_data)) {
  //     fetch_work_status_data?.forEach((department) => {
  //       const deptName = department.department_name || "No Department";

  //       visibleRows.push({
  //         id: deptName,
  //         name: deptName,
  //         count: department.count,
  //         isGroup: true,
  //       });

  //       if (expandedGroups[deptName]) {
  //         department.data.forEach((child, index) => {
  //           visibleRows.push({
  //             ...child,
  //             id: `child-${deptName}-${index}`,
  //             isGroup: false,
  //             project_manager_name: child.project_manager?.name || "",
  //             project_manager_id: child.project_manager?.user_id ?? null,
  //             skills:
  //               child.area_of_expertise?.map((s) => s.skill_name).join(", ") ||
  //               "",
  //           });
  //         });
  //       }
  //     });
  //   }

  //   return visibleRows;
  // };

  const renderWorkHourCell = (params) => {
    const rows = params.row;
    // if (rows.isGroup) return null;
    return (
      <Box className="column-cell-box">
        <Typography className="workstatus-cell">{rows.work_hours}</Typography>
      </Box>
    );
  };

  const renderProjectManagerCell = (params) => {
    const rows = params.row;
    if (rows.isGroup) return null;
    return (
      <Box className="column-cell-box">
        <Box
          sx={{
            width: 180,
            backgroundColor: isDarkMode ? "transparent" : "#F6F6F6",
            borderRadius: "8px",
            padding: "6px 12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            className="timelog-user"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {rows.project_manager_name}
          </Typography>
        </Box>
      </Box>
    );
  };

  const renderWorkStatusCell = (params) => {
    const rows = params.row;
    // if (rows.isGroup) return null;
    const status = rows.work_status;

    const getWorkStatusStyle = (val) => {
      switch (val) {
        case "BENCH": return { bg: "#f8d7da", color: "#a31616", border: "1px solid #f5c6cb" };
        case "ENGAGED": return { bg: "#d1ecf1", color: "#0c5460", border: "1px solid #bee5eb" };
        case "SHORTLY_AVAILABLE": return { bg: "#e2d6f6", color: "#6f42c1", border: "1px solid #c8b6e2" };
        case "LONG_TERM":
        case "LONG-TERM": return { bg: "#e2f0cb", color: "#4b7902", border: "1px solid #c8e6b8" };
        default: return { bg: "transparent", color: "inherit", border: "1px solid transparent" };
      }
    };

    const formatStatus = (val) => {
      if (!val) return "-";
      if (val === "LONG_TERM" || val === "LONG-TERM") return "Long Term";
      if (val === "SHORTLY_AVAILABLE") return "Shortly Available";
      return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    };

    const style = getWorkStatusStyle(status);

    return (
      <Box className="column-cell-box" sx={{ width: "100%", justifyContent: "center" }}>
        <Box sx={{ 
          backgroundColor: style.bg, 
          color: style.color, 
          border: style.border, 
          padding: "6px 16px", 
          borderRadius: "8px",
          fontWeight: 500,
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "120px"
        }}>
          {formatStatus(status)}
        </Box>
      </Box>
    );
  };

  const renderExpertiseCell = (params) => {
    const rows = params.row;
    if (rows.isGroup) return null;
    return (
      <Box className="column-cell-box" sx={{ flex: 1 }}>
        <Typography className="timelog-user">{rows.skills}</Typography>
      </Box>
    );
  };

  const renderWorkTillCell = (params) => {
    const rows = params.row;
    if (rows.isGroup) return null;
    return (
      <Box className="column-cell-box">
        <Typography className="timelog-user">{rows.date}</Typography>
      </Box>
    );
  };

  // const columns = [
  //   {
  //     field: "arrow",
  //     headerName: "Action",
  //     width: 100,
  //     renderCell: (params) => {
  //       const row = params.row;
  //       if (row.isGroup) {
  //         return (
  //           <Box display="flex " alignItems="center" sx={{ marginTop: 1 }}>
  //             <IconButton onClick={() => handleToggle(row.id)}>
  //               {expandedGroups[row.id] ? (
  //                 <ExpandLessIcon />
  //               ) : (
  //                 <ExpandMoreIcon />
  //               )}
  //             </IconButton>
  //           </Box>
  //         );
  //       }
  //     },
  //   },

  //   {
  //     field: "name",
  //     headerName: "Name",
  //     minWidth: 350,
  //     flex: 1,
  //     renderCell: (params) => {
  //       const row = params.row;
  //       if (row.isGroup) {
  //         return (
  //           <Box display="flex " alignItems="center" padding={2}>
  //             <Typography
  //               className="timelog-user"
  //               sx={{ color: "#000000", marginBottom: 1 }}
  //             >
  //               {row.name}
  //             </Typography>
  //           </Box>
  //         );
  //       }
  //       return (
  //         // <Box sx={{ alignItems: "center", height: 50, display: "flex" }}>
  //         //   <div style={{ display: "flex", flexDirection: "column" }}>
  //         //     <Typography
  //         //       variant="body1"
  //         //       // sx={{ fontWeight: 500, fontSize: 15, color: "#626161" }}

  //         //       className="timelog-user"
  //         //     >
  //         //       {row.user_name}
  //         //     </Typography>
  //         //     <Typography
  //         //       variant="body2"
  //         //       color="text.secondary"
  //         //       sx={{ fontWeight: 400, fontSize: 12, color: "#838088" }}
  //         //     >
  //         //       {row.designation} | {row.relevant_experience}
  //         //     </Typography>
  //         //   </div>
  //         // </Box>

  //         <Box
  //           sx={{
  //             height: "100%",
  //             width: "100%",
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "center",
  //           }}
  //         >
  //           <Box
  //             sx={{
  //               height: "100%",
  //               width: "85%",
  //               display: "flex",
  //               flexDirection: "column",
  //               alignItems: "center",
  //               justifyContent: "flex-start",
  //               paddingTop: 2,
  //               paddingBottom: 2,
  //             }}
  //           >
  //             <Typography
  //               className="timelog-user"
  //               sx={{
  //                 alignSelf: "start",
  //                 textAlign: "start",
  //                 letterSpacing: 0,
  //                 marginBottom: 1,
  //               }}
  //             >
  //               {row.user_name}
  //             </Typography>
  //             <Typography
  //               sx={{
  //                 fontSize: 12,
  //                 color: "#838088",
  //                 alignSelf: "start",
  //                 textAlign: "start",
  //               }}
  //             >
  //               {row.designation} | {row.relevant_experience}
  //             </Typography>
  //           </Box>
  //         </Box>
  //       );
  //     },
  //   },
  //   {
  //     field: "workHours",
  //     headerName: "Work Hours",
  //     renderCell: renderWorkHourCell,
  //     minWidth: 128,
  //   },
  //   {
  //     field: "expertise",
  //     headerName: "Area of Expertise",
  //     renderCell: renderExpertiseCell,
  //     minWidth: 400,
  //   },
  //   {
  //     field: "projectManager",
  //     headerName: "Project Manager",
  //     renderCell: renderProjectManagerCell,
  //     minWidth: 200,
  //   },
  //   {
  //     field: "workTill",
  //     headerName: "Work Till",
  //     renderCell: renderWorkTillCell,
  //     minWidth: 200,
  //   },
  // ];

  const columns = [
    {
      field: "arrow",
      headerName: "Action",
      width: 100,
      renderCell: (params) => {
        const row = params.row;
        if (row.isGroup) {
          return (
            <Box display="flex " alignItems="center" sx={{ marginTop: 1 }}>
              <IconButton onClick={() => handleToggle(row.id)}>
                {expandedGroups[row.id] ? (
                  <ExpandLessIcon />
                ) : (
                  <ExpandMoreIcon />
                )}
              </IconButton>
            </Box>
          );
        }
      },
    },

    {
      field: "name",
      headerName: "Name",
      width: 350,
      flex: 1,
      renderCell: (params) => {
        const row = params.row;

        if (row.isGroup) {
          return (
            <Box display="flex" alignItems="center" padding={2}>
              <Typography
                className="timelog-user"
                sx={{ color: "#000000", marginBottom: 1 }}
              >
                {row.name}
              </Typography>
            </Box>
          );
        }

        if (!row.showUser) return null;

        return (
          <Box
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: "85%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                paddingTop: 2,
                paddingBottom: 2,
              }}
            >
              <Typography
                className="timelog-user"
                sx={{
                  alignSelf: "start",
                  textAlign: "start",
                  letterSpacing: 0,
                  marginBottom: 1,
                }}
              >
                {row.user_name}
              </Typography>
              <Typography
                sx={{
                  fontSize: 12,
                  color: "#838088",
                  alignSelf: "start",
                  textAlign: "start",
                }}
              >
                {row.designation} | {row.relevant_experience}
              </Typography>
            </Box>
          </Box>
        );
      },
    },

    {
      field: "workHours",
      headerName: "Work Hours",
      renderCell: renderWorkHourCell,
      minWidth: 128,
    },
    {
      field: "expertise",
      headerName: "Area of Expertise",
      renderCell: renderExpertiseCell,
      minWidth: 400,
    },
    {
      field: "projectManager",
      headerName: "Project Manager",
      renderCell: renderProjectManagerCell,
      minWidth: 200,
    },
    {
      field: "work_status",
      headerName: "Work Status",
      renderCell: renderWorkStatusCell,
      minWidth: 200,
    },
    {
      field: "workTill",
      headerName: "Work Till",
      renderCell: renderWorkTillCell,
      minWidth: 200,
    },
  ];

  const onCloseSummary = () => {
    setShowSummary(!showSummary);
  };

  const exportToExcel = async () => {
    const requestedData = {
      date: format(selectionRange.startDate, "dd-MM-yyyy"),
    };
    // if (userId) {
    //   requestedData.user_id = userId;
    // }
    
    try {
      const response = await createEntity(
        "task-allocation/export",
        requestedData,
      );
      if (response?.doc_url) {
        toast.success(response.message);

        // Trigger the download
        const link = document.createElement("a");
        link.href = response.doc_url;
        link.setAttribute("download", "MonthlyLogs.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  
  return (
    <div style={{ padding: "16px 0px" }} className="bg-white">
      <Box style={{ width: "100%", backgroundColor: "transparent" }}>
        <Offcanvas placement="end" show={showSummary} style={{ width: "30%" }}>
          <OffcanvasBody>
            <BenchSummary
              benchSummary={benchDetails}
              selectedDate={format(selectionRange.startDate, "dd-MM-yyyy")}
              selectedDepartment={selectedDepartmentName}
              onClose={onCloseSummary}
            />
          </OffcanvasBody>
        </Offcanvas> 

        <div
          className="d-flex align-items-center justify-content-between flex-nowrap gap-3"
          style={{
            border: isDarkMode
              ? "1px solid rgba(255, 255, 255, 0.15)"
              : "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: "6px",
            padding: "10px 12px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
            marginBottom: "15px",
          }}
        >
          <div className="d-flex align-items-center gap-3 flex-nowrap">
            <div className="d-flex align-items-center" style={{ gap: "4px" }}>
              <FormControl size="small" className="card-like-select">
                <Select
                  value={benchFilter}
                  displayEmpty
                  onChange={(e) => {
                    setBenchFilter(e.target.value);
                    //setIsExport(false);
                    hasDownloaded.current = false;
                  }}
                  className="dropdown-label"
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        borderRadius: "5px",
                      },
                    },
                  }}
                >
                  {filterOptions.status.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      sx={{ color: option.color }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* Department */}
            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
              <FormControl size="small" className="card-like-select">
                <Select
                  value={departmentFilter}
                  onChange={(e) => {
                    setDepartmentFilter(e.target.value);
                    hasDownloaded.current = false;
                  }}
                  displayEmpty
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        borderRadius: "5px",
                      },
                    },
                  }}
                  className="dropdown-label"
                >

                  <MenuItem value="" sx={{ color: "var(--text-color)" }}>
                    All Departments
                  </MenuItem>
                  {/* {allDepartments?.map((option) => ( */}
                  {allDepartments
                    ?.filter((opt) => opt.department_id !== null && opt.department_name !== "All")
                    ?.map((option) => (
                      <MenuItem
                        key={option.department_id}
                        value={option.department_id}
                        sx={{ color: "var(--text-color)" }}
                      >
                        {option.department_name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
          </div>

          {/* Center: Calendar */}
          <div
            className="d-flex align-items-center justify-content-center gap-2"
            style={{ minWidth: 300 }}
          >
            <IconButton
              onClick={() => {
                handleArrowClick("prev");
              }}
            >
              <ArrowBackIosIcon />
            </IconButton>
            <div>
              <CustomTasksCalender
                selectionRange={selectionRange}
                setSelectionRange={(range) => setSelectionRange(range)}
              />
            </div>
            <IconButton
              onClick={() => {
                handleArrowClick("next");
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </div>

          {/* Right: Search, Bench Image, Clear Filter, Export */}
          <div className="d-flex align-items-center flex-nowrap" style={{ gap: "10px" }}>
            <SearchBar
              placeholder="Search Staff Name"
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            />

            {/* Bench Image */}
            <Tooltip
              title={
                <div>
                  <span style={{ color: "#4caf50" }}></span>Bench Summary
                </div>
              }
            >
              <div>
                {/* <button
                  className="border-0 p-2 bg-transparent rounded-circle" */}
                <IconButton
                  className="d-flex align-items-center justify-content-center me-2"
                  sx={{
                    backgroundColor: isDarkMode
                      ? "rgba(67, 105, 255, 0.08)"
                      : "#F1F5FF",
                    borderRadius: "50%",
                    marginRight:"10px",
                    width: "42px",
                    height: "42px",
                    padding: "5px",
                  }}
                  onClick={() => {
                    setShowSummary(!showSummary);
                  }}
                >
                  {/* <img src={BenchImage} alt="Bench" width={24} height={24} />
                </button> */}
                  <FiLayers size={24} color="rgba(18, 183, 159, 1)" strokeWidth={1} />
                </IconButton>
              </div>
            </Tooltip>

            {clearFilter && (
              <button
                className="btn btn-outline-secondary"
                disabled={loading}
                onClick={handleClearFilter}
              >
                Clear
              </button>
            )}
            <Tooltip
              title={
                <div>
                  <span style={{ color: "white" }}>Export</span>
                </div>
              }
            >
              <IconButton
                className="d-flex align-items-center justify-content-center"
                sx={{
                  backgroundColor: isDarkMode
                    ? "rgba(67, 105, 255, 0.08)"
                    : "#F1F5FF",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  padding: "5px",
                }}
                onClick={() => {
                  // exportToExcel();
                  // setIsExport(true);
                  handleTableExport();
                }}
              >
                <CiExport size={22} color="rgba(18, 183, 159, 1)" />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </Box>

      {isLoading ? (
        <Loader />
      ) : (
        <div className="my-2">
          {/* <DataGrid
            rows={getVisibleRows()}
            columns={columns}
            getRowId={(row) => row.id?.toString?.() || String(Math.random())}
            rowHeight={70}
            // getRowHeight={() => "auto"}
            row
            getRowClassName={(params) =>
              params.row.showUser ? "first-task-row" : ""
            }
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            disableRowSelectionOnClick
            columnBufferPx={5}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "var(--cell-bg-color)",
                fontWeight: "bold",
                fontSize: "14px",
              },
              "& .MuiDataGrid-cell": {
                borderRight: "1px solid #e0e0e0",
                fontSize: "13px",
                color: "#444",
                whiteSpace: "normal !important",
                wordBreak: "break-word",
                alignItems: "start", //
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#f9f9f9",
              },
              "& .sticky-column": {
                position: "sticky",
                left: 0,
                zIndex: 1,
                backgroundColor: "var(--cell-bg-color)",
              },
              "& .action-col": {
                left: 200, // 👈 equal to name column width
              },
            }}
          /> */}

          {/* <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
            <Table stickyHeader sx={{ boxShadow: "none", border: "none" }}>
              <TableHead>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Work Hours</TableCell>
                  <TableCell>Area of Expertise</TableCell>
                  <TableCell>Project Manager</TableCell>
                  <TableCell>Work Till</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fetch_work_status_data.map((dept, deptIndex) =>
                  dept.data.map((user, userIndex) => {
                    const taskCount = user.tasks.length;

                    return user.tasks.map((task, taskIndex) => (
                      <TableRow key={`user-${user.user_id}-task-${taskIndex}`}>
                        {taskIndex === 0 && (
                          <>
                            <TableCell
                              sx={{ borderRight: "1px solid #e0e0e0" }}
                              rowSpan={taskCount}
                            >
                              {deptIndex + 1}
                            </TableCell>
                            <TableCell
                              sx={{ borderRight: "1px solid #e0e0e0" }}
                              rowSpan={taskCount}
                            >
                              {user.user_name}
                            </TableCell>
                          </>
                        )}

                        <TableCell sx={{ borderRight: "1px solid #e0e0e0" }}>
                          {task.work_hours}
                        </TableCell>

                        <TableCell sx={{ borderRight: "1px solid #e0e0e0" }}>
                          {user.area_of_expertise
                            .map((skill) => skill.skill_name)
                            .join(", ")}
                        </TableCell>

                        <TableCell sx={{ borderRight: "1px solid #e0e0e0" }}>
                          {task.project_manager?.name || "N/A"}
                        </TableCell>
                        <TableCell sx={{ borderRight: "1px solid #e0e0e0" }}>
                          {task.work_till || "N/A"}
                        </TableCell>
                        <TableCell sx={{ borderRight: "1px solid #e0e0e0" }}>
                          <Button variant="outlined" size="small">
                            View
                          </Button>
                        </TableCell>
                      </TableRow>
                    ));
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer> */}
          <TableContainer component={Paper} sx={{ maxHeight: 545 }}>
            <Table
              stickyHeader
              sx={{
                boxShadow: "none",
                borderCollapse: "collapse",
                "& td, & th": {
                  borderRight: "1px solid rgba(224, 224, 224, 1)",
                  borderTop: "1px solid rgba(224, 224, 224, 1)",
                },
                // "& td:last-child, & th:last-child": {
                //   borderRight: "none", // remove extra right border
                // },
              }}
            >
              <TableHead>
                <TableRow>
                  {/* <TableCell /> */}
                  <TableCell sx={{ minWidth: 80, width: 80, whiteSpace: "nowrap" }}>
                    <Typography className="workstatus-header-cell">
                      Action
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ minWidth: 350, width: 350, whiteSpace: "nowrap" }}>
                    <Typography className="workstatus-header-cell">
                      Name
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ minWidth: 180, width: 180, whiteSpace: "nowrap" }}>
                    <Typography className="workstatus-header-cell">
                      Project Title
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ minWidth: 250, width: 250, whiteSpace: "nowrap" }}>
                    <Typography className="workstatus-header-cell">
                      Task List
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ minWidth: 180, width: 180, whiteSpace: "nowrap" }}>
                    <Typography className="workstatus-header-cell">
                      Project Manager
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ minWidth: 150, width: 150, whiteSpace: "nowrap" }}>
                    <Typography className="workstatus-header-cell">
                      Work Status
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ minWidth: 100, width: 100, whiteSpace: "nowrap" }}>
                    <Typography className="workstatus-header-cell">
                      Work Hours
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ minWidth: 100, width: 100, whiteSpace: "nowrap" }}>
                    <Typography className="workstatus-header-cell">
                      Work Till
                    </Typography>
                  </TableCell>

                  <TableCell sx={{ minWidth: 180, width: 180, whiteSpace: "nowrap" }}>
                    <Typography className="workstatus-header-cell">
                      Area of Expertise
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fetch_work_status_data?.length === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={9}
                      sx={{ textAlign: "center", height: 200 }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          fontSize: "16px",
                          fontWeight: "bold",
                          backgroundColor: isDarkMode ? "#272626" : "#f0f0f0",
                          color: isDarkMode ? "white" : "#888",
                        }}
                      >
                        No data found
                      </Box>
                    </TableCell>
                  </TableRow>
                )}

                {fetch_work_status_data.map((dept) => (
                  <React.Fragment key={dept.department_id}>
                    {/* Department Row */}
                    <TableRow sx={{ backgroundColor: "transparent" }}>
                      <TableCell
                        sx={{
                          borderBottom: "1px solid rgba(224,224,224,1)", // default border color
                          verticalAlign: "top",
                        }}
                      >
                        <IconButton
                          size="small"
                          onClick={() => toggleDept(dept.department_id)}
                        >
                          {expandedDepts[dept.department_id] ? (
                            <ExpandLessIcon />
                          ) : (
                            <ExpandMoreIcon />
                          )}
                        </IconButton>
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          borderRight: "1px solid rgba(224,224,224,1)",
                          borderBottom: "1px solid rgba(224,224,224,1)",
                          minWidth: 350,
                          width: 350,
                        }}
                      >
                        {dept.department_name}
                      </TableCell>
                      <TableCell
                        sx={{
                          borderRight: "1px solid rgba(224,224,224,1)",
                          borderBottom: "1px solid rgba(224,224,224,1)",
                        }}
                      />
                      <TableCell
                        sx={{
                          borderRight: "1px solid rgba(224,224,224,1)",
                          borderBottom: "1px solid rgba(224,224,224,1)",
                        }}
                      />
                      <TableCell
                        sx={{
                          borderRight: "1px solid rgba(224,224,224,1)",
                          borderBottom: "1px solid rgba(224,224,224,1)",
                        }}
                      />
                      <TableCell
                        sx={{
                          borderRight: "1px solid rgba(224,224,224,1)",
                          borderBottom: "1px solid rgba(224,224,224,1)",
                        }}
                      />
                      <TableCell
                        sx={{
                          borderRight: "1px solid rgba(224,224,224,1)",
                          borderBottom: "1px solid rgba(224,224,224,1)",
                        }}
                      />
                      <TableCell
                        sx={{
                          borderRight: "1px solid rgba(224,224,224,1)",
                          borderBottom: "1px solid rgba(224,224,224,1)",
                        }}
                      />
                      <TableCell
                        sx={{
                          borderRight: "1px solid rgba(224,224,224,1)",
                          borderBottom: "1px solid rgba(224,224,224,1)",
                        }}
                      />
                    </TableRow>

                    {/* Expanded Users/Tasks Rows */}
                    {expandedDepts[dept.department_id] &&
                      dept.data.map((user) => {
                        const taskCount = user.tasks.length;
                        return user.tasks.map((task, taskIndex) => (
                          <TableRow
                            key={`user-${user.user_id}-task-${taskIndex}`}
                          >
                            <TableCell
                              sx={{
                                borderBottom:
                                  taskIndex === taskCount - 1
                                    ? "1px solid rgba(224,224,224,1)"
                                    : "none",
                              }}
                            />{" "}
                            {/* Hide unwanted row line */}
                            {/* Name cell - rowspan */}
                            {taskIndex === 0 && (
                              <>
                                <TableCell
                                  rowSpan={taskCount}
                                  sx={{
                                    borderBottom:
                                      "1px solid rgba(224,224,224,1)",
                                    verticalAlign: "center",
                                    minWidth: 350,
                                    width: 350,
                                  }}
                                >
                                  <Box
                                    display="flex "
                                    flexDirection="column"
                                    alignItems="flex-start"
                                    justifyContent="flex-start"
                                    padding={1}
                                  >
                                    <Typography className="timelog-user">
                                      {user.user_name}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: 12,
                                        color: "#838088",
                                        // marginTop: 0.5,
                                      }}
                                    >
                                      {user.designation} |{" "}
                                      {user.relevant_experience}
                                    </Typography>
                                  </Box>
                                </TableCell>
                              </>
                            )}
                            {/* Project Title */}
                            <TableCell>
                              <Box
                                className="column-cell-box"
                                sx={{
                                  width: 180,
                                }}
                              >
                                <Typography
                                  className="timelog-user"
                                  sx={{ flex: 1 }}
                                >
                                  {task.project.title}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  width: 250,
                                  height: "auto",
                                  minHeight: 40,
                                  overflow: "auto",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                  scrollbarWidth: "none",
                                  display: "flex",
                                  alignItems:
                                    task.task_list?.length <= 5
                                      ? "center"
                                      : "flex-start",
                                  justifyContent:
                                    task.task_list?.length <= 5
                                      ? "center"
                                      : "flex-start",
                                  textAlign:
                                    task.task_list?.length <= 5
                                      ? "center"
                                      : "left",
                                  "&::-webkit-scrollbar": {
                                    display: "none",
                                  },
                                  padding: "8px",
                                }}
                              >
                                <Typography className="workstatus-cell">
                                  {task.task_list}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box className="column-cell-box">
                                <Box
                                  sx={{
                                    width: 180,
                                    backgroundColor: isDarkMode
                                      ? "transparent"
                                      : "#F6F6F6",
                                    borderRadius: "8px",
                                    padding: "6px 12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Typography
                                    className="timelog-user"
                                    sx={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {task.project_manager.name}
                                  </Typography>
                                </Box>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                className="column-cell-box"
                                sx={{ width: 150, display: "flex", justifyContent: "center" }}
                              >
                                <Box
                                  sx={{ 
                                    backgroundColor: (() => {
                                      if (isDarkMode) {
                                        switch (task.work_status) {
                                          case "BENCH": return "rgba(239, 68, 68, 0.15)";
                                          case "ENGAGED": return "rgba(14, 165, 233, 0.15)";
                                          case "SHORTLY_AVAILABLE": return "rgba(168, 85, 247, 0.15)";
                                          case "LONG_TERM":
                                          case "LONG-TERM": return "rgba(34, 197, 94, 0.15)";
                                          default: return "transparent";
                                        }
                                      }
                                      switch (task.work_status) {
                                        case "BENCH": return "#f8d7da";
                                        case "ENGAGED": return "#d1ecf1";
                                        case "SHORTLY_AVAILABLE": return "#e2d6f6";
                                        case "LONG_TERM":
                                        case "LONG-TERM": return "#e2f0cb";
                                        default: return "transparent";
                                      }
                                    })(),
                                    color: (() => {
                                      if (isDarkMode) {
                                        switch (task.work_status) {
                                          case "BENCH": return "#FF8A8A";
                                          case "ENGAGED": return "#38BDF8";
                                          case "SHORTLY_AVAILABLE": return "#C084FC";
                                          case "LONG_TERM":
                                          case "LONG-TERM": return "#4ADE80";
                                          default: return "inherit";
                                        }
                                      }
                                      switch (task.work_status) {
                                        case "BENCH": return "#a31616";
                                        case "ENGAGED": return "#0c5460";
                                        case "SHORTLY_AVAILABLE": return "#6f42c1";
                                        case "LONG_TERM":
                                        case "LONG-TERM": return "#4b7902";
                                        default: return "inherit";
                                      }
                                    })(),
                                    border: (() => {
                                      if (isDarkMode) {
                                        switch (task.work_status) {
                                          case "BENCH": return "1px solid rgba(239, 68, 68, 0.3)";
                                          case "ENGAGED": return "1px solid rgba(14, 165, 233, 0.3)";
                                          case "SHORTLY_AVAILABLE": return "1px solid rgba(168, 85, 247, 0.3)";
                                          case "LONG_TERM":
                                          case "LONG-TERM": return "1px solid rgba(34, 197, 94, 0.3)";
                                          default: return "1px solid transparent";
                                        }
                                      }
                                      switch (task.work_status) {
                                        case "BENCH": return "1px solid #f5c6cb";
                                        case "ENGAGED": return "1px solid #bee5eb";
                                        case "SHORTLY_AVAILABLE": return "1px solid #c8b6e2";
                                        case "LONG_TERM":
                                        case "LONG-TERM": return "1px solid #c8e6b8";
                                        default: return "1px solid transparent";
                                      }
                                    })(),
                                    padding: "6px 16px",
                                    borderRadius: "8px",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minWidth: "120px"
                                  }}
                                >
                                  {(() => {
                                    const val = task.work_status;
                                    if (!val) return "-";
                                    if (val === "LONG_TERM" || val === "LONG-TERM") return "Long Term";
                                    if (val === "SHORTLY_AVAILABLE") return "Shortly Available";
                                    return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
                                  })()}
                                </Box>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                className="column-cell-box"
                                sx={{ width: 100 }}
                              >
                                <Typography className="workstatus-cell">
                                  {task.work_hours}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell>
                              {" "}
                              <Box
                                className="column-cell-box"
                                sx={{ width: 100 }}
                              >
                                <Typography className="timelog-user">
                                  {task.work_till
                                    ? dayjs(task.work_till).format("DD-MM-YYYY")
                                    : task.work_till}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Box
                                className="column-cell-box"
                                sx={{ flex: 1, width: 180 }}
                              >
                                <Typography className="timelog-user">
                                  {user.area_of_expertise
                                    .map((skill) => skill.skill_name)
                                    .join(", ")}
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ));
                      })}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
    </div>
  );
}

export default WorkStatus;


